import {Component, Input, OnInit} from '@angular/core';
import {ScreenManagerService} from '../../../core/services/screen-manager.service';
import {KamonaLayoutHeightUnit} from '../../model/kamonal-model';

@Component({
	selector: 'app-kamona-layout',
	templateUrl: './kamona-layout.component.html',
	styleUrls: ['./kamona-layout.component.scss']
})
export class KamonaLayoutComponent implements OnInit {
	@Input() minHeight:any;
	@Input() minResizableHeightInPX = 480;
	savedMinHeight: any;
	readonly DefaultMinHeight = 'inherit';
	@Input() type = 'version1';
	@Input() headerClass = '';
	@Input() contentClass = '';
	@Input() footerClass = '';
	@Input() id = '';
	@Input() hasContentFooter = false;
	@Input() heightUnit: KamonaLayoutHeightUnit;
	inherentHeight:any;

	constructor(private screenManager: ScreenManagerService) {
	}

	ngOnInit(): void {
		if (!this.minHeight) {
			this.minHeight = this.DefaultMinHeight;
		}
		if (!this.heightUnit) {
			this.heightUnit = KamonaLayoutHeightUnit.CUSTOM;
		}
		this.savedMinHeight = `${this.minHeight}${this.heightUnit}`;
		this.resetMinHeight(this.screenManager.getHeight());
		this.screenManager.isHeight$
			.subscribe(height => {
				this.resetMinHeight(height);
			});
	}

	resetMinHeight(screenHeight: number) {
		this.minHeight = screenHeight < this.minResizableHeightInPX
			? `${this.minResizableHeightInPX}${KamonaLayoutHeightUnit.PX}`
			: this.savedMinHeight;
	}

}
